import { ReactElement } from 'react';
import ExerciseManagement from '../../../components/exercise/ExerciseManagement';

const AdminExercises = (): ReactElement => {
  return (
    <ExerciseManagement mode="admin" />
  )
}

export default AdminExercises